export default __webpack_public_path__ + "static/media/18_2.4c428caf.jpg";